export const enum FreeSpinEventType {
  Init = 'Init',
  Collect = 'Collect',
  Add = 'Add',
  Bonus = 'Bonus',
}
